function invalidCharacters(str: string): string {
    const invalid = /[°"§%()\[\]{}=\\?´`'#<>|,;.:+_-]+/g;

    return str.replace(invalid, '');
}

// ----------------------------------------------------------------------------

export default invalidCharacters;
